// https://vuex.vuejs.org/en/actions.html
import {
  VACA,
  ZEBUINO,
  CRUZADO_CORTE,
  CRUZADO_LEITE,
  LACTANTE,
  GESTANTE_LACTANTE,
  ID_LEITE_VACA,
  ID_UREIA
} from '@/utils/types'
import { parseString, replaceSpecialChars, parseMoney } from '@/utils/vuex'
import { normaliza, calculaProporcao, calculaPesoCV, calculaPCVZ, calculaKmKg, createMD5 } from '@/utils/utils'
import Vue from 'vue'
import Animal from '@/models/Animal'
import { deepClone, resolveProteinas, round } from '../dietas/actions'

export const getDefaultPredicao = async ({ commit, state, dispatch }, { step }) => {
  dispatch('getAditivos')
  dispatch('getTipos')
  commit('getDefaultVC')
  commit('getDefaultTipoAlimentoPredicao')
  commit('getDefaultAnimalPredicao')
  commit('getDefaultExigencias')
  commit('getDefaultComposicaoRacao')
  commit('getDefaultComposicaoDieta')
  commit('setTipoAnimal', state.app.animal)
  state.app.tipo = 'PD'
  state.app.step = step
  state.app.animal_ = new Animal(state)
  state.app.animal = state.app.animal_.getData()
}
export const calculaPredicao = ({ commit, state }, params = {}) => {
  const { onlyReturn = false } = params
  const idioma = state.app.idioma
  const unidades = state.app.unidades
  const animal = state.app.animal
  const raca = animal.raca.valor
  const alimentos = Object.values(state.app.alimentos_selecionados)
  const exigencias = state.app.exigencias
  const exigenciasResultado = state.app.exigencias_resultados
  let composicaoRacao = !onlyReturn ? state.app.composicao_racao : deepClone(state.app.composicao_racao)
  let composicaoDieta = !onlyReturn ? state.app.composicao_dieta : deepClone(state.app.composicao_dieta)
  let aditivos = !onlyReturn ? state.app.aditivos : deepClone(state.app.aditivos)
  let excrecao = !onlyReturn ? state.app.excrecao : deepClone(state.app.excrecao)
  let totalMN = 0
  let totalMS = 0
  let totalMSConc = 0
  let valor = 0
  let unidade = null
  let dadosPredicao = state.app.dados_predicao
  const pesoAnimal = parseString(animal.peso_corporal_medio.valor, idioma)
  return new Promise((resolve, reject) => {
    var { pesoConcentrados, pesoVolumosos } = calculaPesoCV(state)
    var kpVolumoso = ((2.365 + 0.0214 * ((pesoVolumosos * 1000) / pesoAnimal) + 0.0734 * ((pesoConcentrados * 1000) / pesoAnimal) + 0.069 * pesoVolumosos) / 100)
    var kpConcentrado = ((1.169 + 0.1375 * ((pesoVolumosos * 1000) / pesoAnimal) + 0.1721 * ((pesoConcentrados * 1000) / pesoAnimal)) / 100)
    var { PCVZ, PCVZeq } = calculaPCVZ(state, animal)
    var alimentosQuantidade = {}
    var ELTotal = 0
    var PMTotal = 0
    var PBMicTotal = 0
    var PNDRTotal = 0
    var PDRTotal = 0
    var PLg = 0
    var quantidadeTotal = 0

    // Transforma a quantidade(formato string) para float
    alimentos.forEach((al) => {
      let alimento = Object.assign({}, al)
      const val = parseString(alimento.quantidade === null ? 0 : alimento.quantidade, idioma)
      const unidade = unidades.find((val) => val.id === alimento.unidade)
      var xProporcao = calculaProporcao(state, alimento)
      alimentosQuantidade[alimento.id] = val * unidade.fator
      quantidadeTotal += alimentosQuantidade[alimento.id]
      var MN = alimentosQuantidade[alimento.id] * xProporcao
      var CMS = MN * parseString(alimento.nutrientes.MS, idioma).toFixed(2) / 100
      var EM = parseString(alimento.nutrientes.EM_BRCORTE2016, idioma).toFixed(2)
      var NDT = parseString(alimento.nutrientes.NDT_BRCORTE2016, idioma).toFixed(2)
      var ED = parseString(alimento.nutrientes.ED_BRCORTE2016, idioma).toFixed(2)
      var quantidade = MN
      var EL = 0;
      if (NDT > 0 && !isNaN(parseFloat(NDT))) {
        ED = (NDT * 4.409) / 100
      }
      if (ED > 0 && !isNaN(parseFloat(ED))) {
        EM = 0.9455 * ED - 0.303
      }
      if (EM != 0 && quantidade > 0) {
        var ELm = -1.12 + (1.37 * EM) - (0.138 * Math.pow(EM, 2)) + (0.0105 * Math.pow(EM, 3))
        var ELg = -1.65 + (1.42 * EM) - (0.174 * Math.pow(EM, 2)) + (0.0122 * Math.pow(EM, 3))
        var km = ELm / EM
        var kg = ELg / EM
        var kmp = (ELm + ELg) / ((ELm / km) + (ELg / kg))
        
        EL = EM * kmp
        EL < 0 ? EL = 0 : EL
        ELg < 0 ? ELg = 0 : ELg
        ELm < 0 ? ELm = 0 : ELm 
      } else {
        ELm = ELg = km = kg = kmp = EL = 0
      }
      if (alimento.id === ID_LEITE_VACA) {
        EL = parseFloat(_.get(alimento, 'nutrientes.EL'))
      }
      if (EL <= 0) EL = 0
      if (!isNaN(parseFloat(EL))) {
        ELTotal += (EL * CMS)
      }

      // Proteina
      // var PDRPB = 0
      let PBA = isNaN(round(alimento.nutrientes["PBA"]))
        ? 0
        : round(alimento.nutrientes["PBA"]);
      let PBB = isNaN(round(alimento.nutrientes["PBB"]))
        ? 0
        : round(alimento.nutrientes["PBB"]);
      let PBKD = isNaN(round(alimento.nutrientes["PBKD"]))
        ? 0
        : round(alimento.nutrientes["PBKD"]);
      let PB = isNaN(round(alimento.nutrientes["PB"]))
        ? 0
        : round(alimento.nutrientes["PB"]);
      let PDRPB = isNaN(round(alimento.nutrientes["PDRPB"]))
        ? 0
        : round(alimento.nutrientes["PDRPB"]);
      let PNDRPB = isNaN(round(alimento.nutrientes["PNDRPB"]))
        ? 0
        : round(alimento.nutrientes["PNDRPB"]);
      let PDR = isNaN(round(alimento.nutrientes["PDR"]))
        ? 0
        : round(alimento.nutrientes["PDR"]);
      let PNDR = isNaN(round(alimento.nutrientes["PNDR"]))
        ? 0
        : round(alimento.nutrientes["PNDR"]);
      let PM = isNaN(round(alimento.nutrientes["PM"]))
        ? 0
        : round(alimento.nutrientes["PM"])
      let kp = (alimento.volumoso || alimento.id === ID_LEITE_VACA) ? kpVolumoso : kpConcentrado
      const proteinas = resolveProteinas({ alimento, kp });
      PDR = proteinas.PDR;
      PNDR = proteinas.PNDR;
      PB = proteinas.PB;
      PM = proteinas.PM;
      NDT = round(alimento.nutrientes.NDT_BRCORTE2016) * 0.01
      
      var PBMic = 0
      if (PB !== 0 || NDT !== 0 || alimento.tipo === 8) {
        PBMic = -53.07 + 304.9 * ((PB * CMS) / 100) + 90.8 * (NDT * CMS) - 3.13 * Math.pow((NDT * CMS), 2)
      }
      var PMAlimento = (PM * CMS)
      composicaoDieta['PNDR'].alimentos[alimento.id] = {}
      composicaoDieta['PNDR'].alimentos[alimento.id].valor = PNDR * CMS * 10
      composicaoDieta['PNDR'].alimentos[alimento.id].valorUnidade = PNDR * CMS * 10
      composicaoDieta['PNDR'].alimentos[alimento.id].unidade = exigencias['PNDR'].unidade
      composicaoDieta['PNDR'].alimentos[alimento.id].id = alimento.id

      composicaoDieta['PM'].alimentos[alimento.id] = {}
      composicaoDieta['PM'].alimentos[alimento.id].valor = PMAlimento
      composicaoDieta['PM'].alimentos[alimento.id].valorUnidade = PMAlimento
      composicaoDieta['PM'].alimentos[alimento.id].unidade = exigencias['PM'].unidade
      composicaoDieta['PM'].alimentos[alimento.id].id = alimento.id

      composicaoDieta['PDR'].alimentos[alimento.id] = {}
      composicaoDieta['PDR'].alimentos[alimento.id].valor = PDR * CMS * 10
      composicaoDieta['PDR'].alimentos[alimento.id].valorUnidade = PDR * CMS * 10
      composicaoDieta['PDR'].alimentos[alimento.id].unidade = exigencias['PDR'].unidade
      composicaoDieta['PDR'].alimentos[alimento.id].id = alimento.id

      composicaoDieta['PB'].alimentos[alimento.id] = {}
      composicaoDieta['PB'].alimentos[alimento.id].valor = quantidade * PB * exigencias['PB'].fator * round(alimento.nutrientes.MS) * exigencias.CMS.fator
      composicaoDieta['PB'].alimentos[alimento.id].valorUnidade = quantidade * PB * exigencias['PB'].fator * round(alimento.nutrientes.MS) * exigencias.CMS.fator
      composicaoDieta['PB'].alimentos[alimento.id].unidade = exigencias['PDR'].unidade
      composicaoDieta['PB'].alimentos[alimento.id].id = alimento.id
      if (alimento.id !== ID_LEITE_VACA) {
        // let EL = exigencias.EL.minimo_raw
        // let EM = exigencias.EM.minimo_raw
        /* composicaoDieta['EL'].alimentos[alimento.id] = {}
            composicaoDieta['EL'].alimentos[alimento.id].valor = kmp * exigencias['EL'].fator * EMAlimento * CMS
            composicaoDieta['EL'].alimentos[alimento.id].valorUnidade = kmp * exigencias['EL'].fator * EMAlimento * CMS
            composicaoDieta['EL'].alimentos[alimento.id].unidade = exigencias['EL'].unidade
            composicaoDieta['EL'].alimentos[alimento.id].id = alimento.id */
      }
      PMTotal += (PM * CMS)
      PBMicTotal += PBMic
      PNDRTotal += (CMS * PNDR * 10)
      PDRTotal += (CMS * PDR * 10)
    })
    if (quantidadeTotal === 0) reject(new Error({}))
    var ELm = 0.075 * Math.pow(PCVZ, 0.75)
    var ELg = ELTotal - ELm
    ELg = ELg < 0 ? 0.1 : ELg
    var GPCVZ = 14.914 * Math.pow(ELg, 0.9662) * Math.pow(PCVZeq, -0.7246)
    var { km, kg } = calculaKmKg(state, PCVZeq, GPCVZ)
    var PCJ = 0
    if (raca === CRUZADO_CORTE || raca === ZEBUINO) {
      PCJ = 0.8915 * Math.pow(pesoAnimal, 1.0151)
    } else if (raca === CRUZADO_LEITE) {
      PCJ = 0.9247 * Math.pow(pesoAnimal, 1.0085)
    }

    // Proteina Mantença
    var PMm = 3.6 * Math.pow(PCJ, 0.75)
    var PDRExigido = parseFloat(_.get(exigencias, 'PDR.minimo'))
    var usePBMic = true
    if (PBMicTotal > PDRExigido && usePBMic && alimentos.findIndex(elm => elm.id === ID_UREIA) !== -1) {
      PMTotal = (PDRExigido * 0.64) + (PNDRTotal * 0.8)
    }
    // PMTotal = (PDRExigido * 0.64) + (PNDRTotal * 0.8)
    var PMg = PMTotal - PMm
    var k = (pesoAnimal > 340) ? 47.4 : (84.665 - (0.1179 * PCVZeq))
    PLg = PMg * (k / 100)

    var erro = Infinity
    var melhor = 0
    GPCVZ = 0
    let it = 0
    
    // Encontra o melhor GPCVZ que minimiza o erro
    for (let i = 0; i < 45000; i++) {
      const aux = Math.abs(
        176.01 * GPCVZ -
        0.381 * Math.pow(PCVZeq, 0.75) * Math.pow(GPCVZ, 1.035) -
        PLg
      );
      
      if (aux < erro) {
        melhor = GPCVZ;
        erro = aux;
      }
      GPCVZ += 0.0001;
    }
    
    
    GPCVZ = melhor
    var GMDPM = Math.pow((GPCVZ / 0.963), 1 / 1.0151)
    var kmp = (ELm + ELg) / ((ELm / km) + (ELg / kg))
    ELTotal = 0

    // 2º ITERAÇÃO
    alimentos.forEach((alimento) => {
      var xProporcao = calculaProporcao(state, alimento)
      var MN = alimentosQuantidade[alimento.id] * xProporcao
      var MS = MN * parseFloat(alimento.nutrientes.MS) / 100
      var EM = (alimento.nutrientes.EM_BRCORTE2016) ? parseFloat(alimento.nutrientes.EM_BRCORTE2016) : 0
      let ED = (alimento.nutrientes.ED_BRCORTE2016) ? parseFloat(alimento.nutrientes.ED_BRCORTE2016) : 0
      let NDT = (alimento.nutrientes.NDT_BRCORTE2016) ? parseFloat(alimento.nutrientes.NDT_BRCORTE2016) : 0
      var EL = 0
      if (NDT > 0 && !isNaN(parseFloat(NDT))) {
        ED = (NDT * 4.409) / 100
      }
      if (ED > 0 && !isNaN(parseFloat(ED))) {
        EM = 0.9455 * ED - 0.303
      }
      if (EM !== 0 && !isNaN(parseFloat(EM))) {
        ELm = -1.12 + (1.37 * EM) - (0.138 * Math.pow(EM, 2)) + (0.00105 * Math.pow(EM, 3))
        ELg = -1.65 + (1.42 * EM) - (0.174 * Math.pow(EM, 2)) + (0.0122 * Math.pow(EM, 3))
        EL = EM * kmp
        EL < 0 ? EL = 0 : EL
        ELg < 0 ? ELg = 0 : ELg
        ELm < 0 ? ELm = 0 : ELm 
      } else {
        ELm = 0
        ELg = 0
        EL = 0
      }

      var ELAlimento = (EL * MS)
      if (isNaN(parseFloat(ELAlimento))) {
        ELAlimento = 0
      }
      ELTotal += ELAlimento
      isNaN(ELAlimento) ? ELAlimento = 0 : ELAlimento;
      if (ELAlimento > 0) {
        composicaoDieta['EL'].alimentos[alimento.id] = {}
        composicaoDieta['EL'].alimentos[alimento.id].valor = ELAlimento
        composicaoDieta['EL'].alimentos[alimento.id].valorUnidade = ELAlimento
        composicaoDieta['EL'].alimentos[alimento.id].unidade = exigencias['EL'].unidade
        composicaoDieta['EL'].alimentos[alimento.id].id = alimento.id
      }
    })
    ELm = 0.075 * Math.pow(PCVZ, 0.75)
    ELg = ELTotal - ELm
    ELg = ELg < 0 ? 0.1 : ELg
    var GPCVZEsp = 14.914 * Math.pow(ELg, 0.9662) * Math.pow(PCVZeq, -0.7246)
    var GMDEL = Math.pow(GPCVZEsp / 0.963, 1 / 1.0151)
    GMDEL = isNaN(GMDEL) ? 0 : GMDEL
    GMDPM = isNaN(GMDPM) ? 0 : GMDPM
    dadosPredicao.GMDEsperado.total = parseString(animal.ganho_medio_diario.valor, idioma)
    dadosPredicao.PGMDEL.total = GMDEL
    dadosPredicao.PGMDPM.total = GMDPM
    dadosPredicao.PGMDPM.erro = erro
    // -----------------------------------

    totalMN = 0
    totalMS = 0
    totalMSConc = 0
    alimentos.forEach((alimento) => {
      var xProporcao = calculaProporcao(state, alimento)
      var MN = alimentosQuantidade[alimento.id] * xProporcao
      totalMN += MN
    })
    alimentos.forEach((alimento) => {
      var xProporcao = calculaProporcao(state, alimento)
      var MN = alimentosQuantidade[alimento.id] * xProporcao
      var quantidade = MN
      if (quantidade !== 0) {
        var ms = parseString(alimento.nutrientes.MS, idioma)
        var materiaSeca = ms * quantidade * 0.01
        totalMS += materiaSeca
        totalMSConc += ((alimento.volumoso) ? 0 : materiaSeca)
        var porcentagemMN = ((quantidade / totalMN) * 100)
        composicaoRacao.MN.alimentos[alimento.id] = {}
        composicaoRacao.MN.alimentos[alimento.id].id = alimento.id
        composicaoRacao.MN.alimentos[alimento.id].valor = quantidade
        valor = quantidade
        unidade = 'kg'
        if (valor < 1) {
          valor = valor * 1000
          unidade = 'g'
          if (valor < 1) {
            valor = valor * 1000
            unidade = 'mg'
          }
        }
        composicaoRacao.MN.alimentos[alimento.id].valorUnidade = valor
        composicaoRacao.MN.alimentos[alimento.id].unidadeEsq = ['', '', '']
        composicaoRacao.MN.alimentos[alimento.id].unidadeDir = [unidade, unidade, unidade]

        composicaoRacao.MNprop.alimentos[alimento.id] = {}
        composicaoRacao.MNprop.alimentos[alimento.id].id = alimento.id
        composicaoRacao.MNprop.alimentos[alimento.id].valor = porcentagemMN
        composicaoRacao.MNprop.alimentos[alimento.id].valorUnidade = porcentagemMN
        composicaoRacao.MNprop.alimentos[alimento.id].unidadeEsq = ['', '', '']
        composicaoRacao.MNprop.alimentos[alimento.id].unidadeDir = ['%', '%', '%']
        composicaoRacao.MN.alimentos[alimento.id].prop = composicaoRacao.MNprop.alimentos[alimento.id]

        composicaoRacao.MS.alimentos[alimento.id] = {}
        composicaoRacao.MS.alimentos[alimento.id].id = alimento.id
        composicaoRacao.MS.alimentos[alimento.id].valor = materiaSeca
        valor = materiaSeca
        unidade = 'kg'
        if (valor < 1) {
          valor = valor * 1000
          unidade = 'g'
          if (valor < 1) {
            valor = valor * 1000
            unidade = 'mg'
          }
        }
        composicaoRacao.MS.alimentos[alimento.id].valorUnidade = valor
        composicaoRacao.MS.alimentos[alimento.id].unidadeEsq = ['', '', '']
        composicaoRacao.MS.alimentos[alimento.id].unidadeDir = [unidade, unidade, unidade]
        if (!alimento.volumoso) {
          composicaoRacao.MSConc.alimentos[alimento.id] = {}
          composicaoRacao.MSConc.alimentos[alimento.id].id = alimento.id
          composicaoRacao.MSConc.alimentos[alimento.id].valor = materiaSeca
          valor = materiaSeca
          unidade = 'kg'
          if (valor < 1) {
            valor = valor * 1000
            unidade = 'g'
            if (valor < 1) {
              valor = valor * 1000
              unidade = 'mg'
            }
          }
          composicaoRacao.MSConc.alimentos[alimento.id].valorUnidade = valor
          composicaoRacao.MSConc.alimentos[alimento.id].unidadeEsq = ['', '', '']
          composicaoRacao.MSConc.alimentos[alimento.id].unidadeDir = [unidade, unidade, unidade]
        }
      }
    })
    var totalCusto = 0
    alimentos.forEach((alimento) => {
      let item = alimento.id
      var xProporcao = calculaProporcao(state, alimento)
      var MN = alimentosQuantidade[alimento.id] * xProporcao
      var quantidade = MN
      let custo = alimento.custo && alimento.custo !== 'R$0,00' && alimento.custo !== 'U$0.00' ? parseMoney(alimento.custo, idioma) * quantidade : 0
      totalCusto = totalCusto + custo
      if (custo) {
        composicaoRacao.CUSTO.alimentos[item] = {}
        composicaoRacao.CUSTO.alimentos[item].id = item
        composicaoRacao.CUSTO.alimentos[item].valor = composicaoRacao.CUSTO.alimentos[item].valorUnidade = custo
        composicaoRacao.CUSTO.alimentos[item].unidadeEsq = ['R$', '$', '$']
        composicaoRacao.CUSTO.alimentos[item].unidadeDir = ['', '', '']
      }
      if (quantidade !== 0) {
        var materiaSeca = composicaoRacao.MS.alimentos[alimento.id].valor
        var porcentagemMN = ((quantidade / totalMN) * 100)
        var totalRacao = (porcentagemMN * animal.total_racao_a_produzir.valor * 0.01)
        composicaoRacao.MSprop.alimentos[alimento.id] = {}
        composicaoRacao.MSprop.alimentos[alimento.id].id = alimento.id
        composicaoRacao.MSprop.alimentos[alimento.id].valor = ((materiaSeca / totalMS) * 100)
        composicaoRacao.MSprop.alimentos[alimento.id].unidadeEsq = ['', '', '']
        composicaoRacao.MSprop.alimentos[alimento.id].unidadeDir = ['%', '%', '%']
        composicaoRacao.MS.alimentos[alimento.id].prop = composicaoRacao.MSprop.alimentos[alimento.id]
        if (!alimento.volumoso) {
          composicaoRacao.MSConcProp.alimentos[alimento.id] = {}
          composicaoRacao.MSConcProp.alimentos[alimento.id].id = alimento.id
          composicaoRacao.MSConcProp.alimentos[alimento.id].valor = ((materiaSeca / totalMSConc) * 100)
          composicaoRacao.MSConcProp.alimentos[alimento.id].unidadeEsq = ['', '', '']
          composicaoRacao.MSConcProp.alimentos[alimento.id].unidadeDir = ['%', '%', '%']
          composicaoRacao.MSConc.alimentos[alimento.id].prop = composicaoRacao.MSConcProp.alimentos[alimento.id]
        }

        composicaoRacao.totalRacao.alimentos[alimento.id] = {}
        composicaoRacao.totalRacao.alimentos[alimento.id].id = alimento.id
        composicaoRacao.totalRacao.alimentos[alimento.id].valor = totalRacao
        valor = composicaoRacao.totalRacao.alimentos[alimento.id].valor
        unidade = 'kg'
        if (valor < 1) {
          valor = valor * 1000
          unidade = 'g'
          if (valor < 1) {
            valor = valor * 1000
            unidade = 'mg'
          }
        }
        composicaoRacao.totalRacao.alimentos[alimento.id].valorUnidade = valor
        composicaoRacao.totalRacao.alimentos[alimento.id].unidadeEsq = ['', '', '']
        composicaoRacao.totalRacao.alimentos[alimento.id].unidadeDir = [unidade, unidade, unidade]
      }
    })
    unidade = 'kg'
    if (totalMN < 1) {
      totalMN = totalMN * 1000
      unidade = 'g'
      if (totalMN < 1) {
        totalMN = totalMN * 1000
        unidade = 'mg'
      }
    }
    composicaoRacao.MN.unidadeDir = [unidade, unidade, unidade]
    unidade = 'kg'
    if (totalMS < 1) {
      totalMS = totalMS * 1000
      unidade = 'g'
      if (totalMS < 1) {
        totalMS = totalMS * 1000
        unidade = 'mg'
      }
    }
    composicaoRacao.MS.unidadeDir = [unidade, unidade, unidade]
    unidade = 'kg'
    if (totalMSConc < 1) {
      totalMSConc = totalMSConc * 1000
      unidade = 'g'
      if (totalMS < 1) {
        totalMSConc = totalMSConc * 1000
        unidade = 'mg'
      }
    }
    composicaoRacao.MSConc.unidadeDir = [unidade, unidade, unidade]
    composicaoRacao.MN.total = totalMN
    composicaoRacao.MNprop.total = 100
    composicaoRacao.MS.total = totalMS
    composicaoRacao.MSprop.total = 100
    composicaoRacao.MSConc.total = totalMSConc
    composicaoRacao.MSConcProp.total = 100
    composicaoRacao.totalRacao.total = parseString(animal.total_racao_a_produzir.valor, idioma)
    composicaoRacao.CUSTO.total = totalCusto

    var pc = ((pesoConcentrados / (pesoConcentrados + pesoVolumosos)) * 100)
    var pv = 100 - pc
    composicaoRacao.proporcaoVC.v = parseInt(pv)
    composicaoRacao.proporcaoVC.c = parseInt(pc)
    // aditivos
    for (let aditivo of aditivos) {
      let unidade = ''
      composicaoDieta[aditivo.id] = { ...aditivo }
      switch (aditivo.unidade) {
        case 'mg/kg':
          unidade = ['mg/dia', 'mg/day', 'mg/día']
          break
        case 'g/kg':
          unidade = ['g/dia', 'g/day', 'g/día']
          break
        case '%/MS':
          unidade = ['kg/dia', 'kg/day', 'kg/día']
          break
      }
      composicaoDieta[aditivo.id].unidade = unidade
      composicaoDieta[aditivo.id].alimentos = {}
    }
    // nutrientes
    alimentos.forEach((alimento) => {
      if (alimento && alimento.id === 'ID_LEITE_VACA') alimento.id = ID_LEITE_VACA
      var xProporcao = calculaProporcao(state, alimento)
      var MN = alimentosQuantidade[alimento.id] * xProporcao
      var quantidade = MN
      var fatorMS = exigencias['CMS'].fator
      var ms = alimento.nutrientes['MS']
      for (let exigencia in exigencias) {
        var id = exigencias[exigencia].id
        var codigo = exigencia
        var fator = exigencias[exigencia].fator
        var valor = parseString(alimento.nutrientes[id], idioma)
        if (codigo !== 'EL' && codigo !== 'PM' && codigo !== 'PB' && codigo !== 'PDR' && codigo !== 'PNDR') {
          if (codigo === 'EM') {
            if (alimento.id !== ID_LEITE_VACA) {
              let EMAlimento = parseFloat(alimento.nutrientes.EM_BRCORTE2016)
              let NDTAlimento = parseFloat(alimento.nutrientes.NDT_BRCORTE2016)
              let EDAlimento = parseFloat(alimento.nutrientes.ED_BRCORTE2016)
              if (NDTAlimento > 0 && !isNaN(parseFloat(NDTAlimento))) {
                EDAlimento = (NDTAlimento * 4.409) / 100
              }
              if (EDAlimento > 0 && !isNaN(parseFloat(EDAlimento))) {
                EMAlimento = 0.9455 * EDAlimento - 0.303
              }
              valor = EMAlimento
            } else {
              valor = (round(alimento.nutrientes['EM_BRCORTE2016']).toFixed(5))
            }
          }
          if (codigo !== 'CMS') {
            valor = valor * fator * ms * fatorMS
          } else {
            valor *= fator
          }
          valor *= quantidade
          valor = (valor < 0) ? 0 : valor
          composicaoDieta[codigo].alimentos[alimento.id] = {}
          composicaoDieta[codigo].alimentos[alimento.id].id = alimento.id
          if (valor > 0) {
            composicaoDieta[codigo].alimentos[alimento.id].valor = valor
          } else {
            composicaoDieta[codigo].alimentos[alimento.id].valor = 0
          }
          composicaoDieta[codigo].alimentos[alimento.id].valorUnidade = composicaoDieta[codigo].alimentos[alimento.id].valor
          composicaoDieta[codigo].alimentos[alimento.id].unidade = exigencias[exigencia].unidade
        }
      }
      // aditivos
      for (let aditivo of aditivos) {
        let prop = (alimento.nutrientes[aditivo.id]) ? parseFloat(alimento.nutrientes[aditivo.id]) : 0
        let fator = 1
        let unidade = ''
        switch (aditivo.unidade) {
          case 'mg/kg':
            fator = 1
            unidade = ['mg/dia', 'mg/day', 'mg/día']
            break
          case 'g/kg':
            fator = 10
            unidade = ['g/dia', 'g/day', 'g/día']
            break
          case '%/MS':
            fator = 0.01
            unidade = ['kg/dia', 'kg/day', 'kg/día']
            break
        }
        if (quantidade > 0 && prop > 0) {
          valor = prop * fator * quantidade * ms * fatorMS
          composicaoDieta[aditivo.id].alimentos[alimento.id] = {}
          composicaoDieta[aditivo.id].alimentos[alimento.id].valor = valor
          composicaoDieta[aditivo.id].alimentos[alimento.id].valorUnidade = valor
          composicaoDieta[aditivo.id].alimentos[alimento.id].unidade = unidade
          composicaoDieta[aditivo.id].alimentos[alimento.id].id = alimento.id
        }
      }

      // exigencias extras

      let AMIDO = (alimento.nutrientes['AMIDO']) ? parseFloat(alimento.nutrientes['AMIDO']) : 0
      let FDNfe = (alimento.nutrientes['FDNfe']) ? parseFloat(alimento.nutrientes['FDNfe']) : 0
      AMIDO = AMIDO * 0.01 * quantidade * ms * fatorMS
      FDNfe = FDNfe * 0.01 * quantidade * ms * fatorMS
      if (composicaoDieta['AMIDO'] === undefined && composicaoDieta['FDNfe'] === undefined) {
        composicaoDieta['AMIDO'] = {}
        composicaoDieta['AMIDO'].id = 'AMIDO'
        composicaoDieta['AMIDO'].alimentos = {}
        composicaoDieta['FDNfe'] = {}
        composicaoDieta['FDNfe'].id = 'FDNfe'
        composicaoDieta['FDNfe'].alimentos = {}
      }
      if (AMIDO > 0) {
        let ex = 'AMIDO'
        let valor = AMIDO
        composicaoDieta[ex].alimentos[alimento.id] = {}
        composicaoDieta[ex].alimentos[alimento.id].valor = valor
        composicaoDieta[ex].alimentos[alimento.id].valorUnidade = valor
        composicaoDieta[ex].alimentos[alimento.id].unidade = exigenciasResultado[ex].unidade

        composicaoDieta[ex].alimentos[alimento.id].id = alimento.id
      }
      if (FDNfe > 0) {
        let ex = 'FDNfe'
        let valor = FDNfe
        composicaoDieta[ex].alimentos[alimento.id] = {}
        composicaoDieta[ex].alimentos[alimento.id].valor = valor

        composicaoDieta[ex].alimentos[alimento.id].valorUnidade = valor
        composicaoDieta[ex].alimentos[alimento.id].unidade = exigenciasResultado[ex].unidade

        composicaoDieta[ex].alimentos[alimento.id].id = alimento.id
      }
    })
    let cd = {}
    for (let ex in exigenciasResultado) {
      if (composicaoDieta[ex]) cd[ex] = composicaoDieta[ex]
    }
    for (let aditivo of aditivos) {
      if (composicaoDieta[aditivo.id]) cd[aditivo.id] = composicaoDieta[aditivo.id]
    }
    composicaoDieta = cd
    for (let exigencia in composicaoDieta) {
      switch (exigencia) {
        case 'Ca':
          valor = 28.14
          var CaLDieta = valor * 0.568
          var Cam = ((11.7 * pesoAnimal) / 1000)
          var CaLG = CaLDieta - Cam
          GPCVZ = CaLG / (147 * Math.pow(PCVZ, -0.5))
          var GMDCa = Math.pow(GPCVZ / 0.963, 1 / 1.0151)
          dadosPredicao.PGMDCa.total = GMDCa
          break
        case 'P':
          valor = 18.52
          var PLDieta = valor * 0.678
          var Pm = ((13.5 * pesoAnimal) / 1000)
          var PLG = PLDieta - Pm
          GPCVZ = PLG / (38.6 * Math.pow(PCVZ, -0.36))
          var GMDP = Math.pow(GPCVZ / 0.963, 1 / 1.0151)
          dadosPredicao.PGMDP.total = GMDP
          break
      }
    }

    var concentradoNDTDieta = 0;
    var concentradoPBDieta = 0;
    Object.values(composicaoRacao.MSConc.alimentos).forEach((alimento) => {
      var alimentoId = alimento.id;
      if (composicaoDieta.NDT.alimentos[alimentoId]) {
        concentradoNDTDieta +=
          composicaoDieta.NDT.alimentos[alimentoId].valor;
      }

      if (composicaoDieta.PB.alimentos[alimentoId]) {
        concentradoPBDieta += composicaoDieta.PB.alimentos[alimentoId].valor;
      }
    });

    if (unidade === "g") {
      totalMSConc = totalMSConc / 1000;
      unidade == "kg"
    }
    if (unidade === "mg") {
      totalMSConc = totalMSConc / 1000000;
      unidade == "kg"
    }

    composicaoDieta.NDT.concentrado =
      (concentradoNDTDieta / totalMSConc) * 100;
    composicaoDieta.PB.concentrado =
      (concentradoPBDieta / 1000 / totalMSConc) * 100;
    composicaoDieta.CMS.concentrado = (totalMSConc / pesoAnimal) * 100;

    let produto = (animal.tipo.valor === VACA && (animal.estado_fisiologico.valor === LACTANTE || animal.estado_fisiologico.valor === GESTANTE_LACTANTE)) ? parseString(animal.producao_de_leite.valor, idioma) : parseString(animal.ganho_medio_diario.valor, idioma)
    let cmsTotal = Object.values(composicaoDieta.CMS.alimentos).map(el => el.valor).reduce((cont, curr) => cont + curr, 0)
    composicaoRacao.eficienciaAlimentar.total = (produto / cmsTotal)

    // Excreção
    let litros = (animal.tipo.valor === VACA && (animal.estado_fisiologico.valor === LACTANTE || animal.estado_fisiologico.valor === GESTANTE_LACTANTE)) ? parseString(animal.producao_de_leite.valor, idioma) : parseString(animal.ganho_medio_diario.valor, idioma)
    unidade = (animal.tipo.valor === VACA && (animal.estado_fisiologico.valor === LACTANTE || animal.estado_fisiologico.valor === GESTANTE_LACTANTE)) ? 'g' : 'g/dia'
    let a = parseString(animal.peso_corporal_medio.valor, idioma)
    let b = Object.values(composicaoDieta.NDT.alimentos).map(el => el.valor).reduce((cont, curr) => cont + curr, 0)
    let c = Object.values(composicaoDieta.PB.alimentos).map(el => el.valor).reduce((cont, curr) => cont + curr, 0)
    let d = Object.values(composicaoDieta.CMS.alimentos).map(el => el.valor).reduce((cont, curr) => cont + curr, 0)
    let e = Object.values(composicaoDieta.P.alimentos).map(el => el.valor).reduce((cont, curr) => cont + curr, 0)
    excrecao.excNFezes.valor = (2.55 + 0.048 * a - 3.47 * b + (0.30 / 6.25) * c)
    excrecao.excNUrina.valor = (3.26 + 3.68 * d + 0.18 * (c / 6.25))
    excrecao.excTotalN.valor = ((2.55 + 0.048 * a - 3.47 * b + (0.30 / 6.25) * c) + (3.26 + 3.68 * d + 0.18 * (c / 6.25)))
    excrecao.excTotalP.valor = (1.90 - 0.0030 * a + 0.53 * e)
    excrecao.producaoMetano.valor = ((37.523 + 19.3276 * d) * (16 / 22.41))
    excrecao.producaoMetanoProduto.valor = (((37.523 + 19.3276 * d) * (16 / 22.41)) / litros)
    for (let ex in composicaoDieta) {
      let alimentosOrdenados = (composicaoDieta[ex].alimentos[ID_LEITE_VACA] !== undefined) ? { ID_LEITE_VACA: composicaoDieta[ex].alimentos[ID_LEITE_VACA] } : {}

      state.app.categorias_alimentos.forEach((cat) => {
        if (Object.keys(composicaoDieta[ex].alimentos).length > 0) {
          cat.derivados.filter((al) => Object.keys(composicaoDieta[ex].alimentos).find((alm) => alm === al.id) !== undefined).sort((a, b) => replaceSpecialChars(a.name) < replaceSpecialChars(b.name) ? -1 : replaceSpecialChars(a.name) > replaceSpecialChars(b.name) ? 1 : 0).forEach(al => {
            alimentosOrdenados[al.id] = composicaoDieta[ex].alimentos[al.id]
          })
        }
      }

      )
      composicaoDieta[ex].alimentos = alimentosOrdenados
    }

    // for (let ex in composicaoDieta) composicaoDieta[ex].alimentos = sortObject(composicaoDieta[ex].alimentos)
    for (let ex in composicaoDieta) for (let al in composicaoDieta[ex].alimentos) if (composicaoDieta[ex].alimentos[al].valor === 0) delete composicaoDieta[ex].alimentos[al]
    for (let exigencia in exigenciasResultado) composicaoDieta[exigencia].total = Object.values(composicaoDieta[exigencia].alimentos).map(el => el.valor).reduce((cont, curr) => cont + curr, 0)
    for (let aditivo of aditivos) composicaoDieta[aditivo.id].total = Object.values(composicaoDieta[aditivo.id].alimentos).map(el => el.valor).reduce((cont, curr) => cont + curr, 0)
    for (let aditivo of aditivos) composicaoDieta[aditivo.id].mg = composicaoDieta[aditivo.id].total / cmsTotal
    for (let exigencia in exigenciasResultado) {
      if (exigenciasResultado[exigencia].unidade[0] === 'g/dia' || exigenciasResultado[exigencia].unidade[0] === 'Mcal/dia') {
      } else if (exigenciasResultado[exigencia].unidade[0] === 'mg/dia') {
      }
      composicaoDieta[exigencia].cms_pv = (exigencia === 'CMS') ? (cmsTotal / parseString(animal.peso_corporal_medio.valor, idioma)) * 100 : 0
      composicaoDieta[exigencia].pcms = (exigencia === 'CMS' || exigencia === 'EL' || exigencia === 'EM') ? 0 : ((parseFloat(composicaoDieta[exigencia].total.toFixed(2))) / exigenciasResultado[exigencia].fator / parseFloat(cmsTotal.toFixed(2)))
      composicaoDieta[exigencia].mcal = (exigencia === 'EL' || exigencia === 'EM') ? ((parseFloat(composicaoDieta[exigencia].total.toFixed(2))) / exigenciasResultado[exigencia].fator / parseFloat(cmsTotal.toFixed(2))) : 0

      composicaoDieta[exigencia].mg = (exigenciasResultado[exigencia].micromineral) ? (exigenciasResultado[exigencia].unidade[0] === 'mg/dia') ? composicaoDieta[exigencia].total / cmsTotal : ((parseFloat(composicaoDieta[exigencia].total.toFixed(2))) / exigenciasResultado[exigencia].fator / parseFloat(cmsTotal.toFixed(2))) : 0
    }
    normaliza(state)
    if (!onlyReturn) {
      commit('setComposicaoRacao', composicaoRacao)
      commit('setComposicaoDieta', composicaoDieta)
      commit('setExcrecao', excrecao)
      commit('setPredicao', dadosPredicao)
    }
    
    resolve({ status: true, dieta: composicaoDieta, racao: composicaoRacao, predicao: dadosPredicao })
  })
}
export const savePredicao = ({ commit, state }, { name, dietaCarregada = null, idCliente = null, obs = null }) => {
  const savePredicao = (state, name, idCliente) => {
    let dietas = JSON.parse(localStorage.getItem('predicoes__'))
    let cliente = JSON.parse(localStorage.getItem('cliente'))
    if (dietas === null || Object.keys(dietas).length === 0) {
      dietas = []
    }
    let dietasEncontradas = dietas.find(n => n.nome === name)
    if (dietasEncontradas !== undefined) {
      name += new Date().getTime()
    }
    let dieta = {}
    // crfia objeto para animal;
    let animal = state.app.animal_.getMobileData()
    let resultado = {}
    for (let id in state.app.composicao_racao['MN'].alimentos) {
      resultado[id] = state.app.composicao_racao['MN'].alimentos[id].valor
    }
    let exigenciasSelecionadas = Array.from(state.app.exigencias_selecionadas)
    let exigenciasAlteradas = {}
    for (let exigencia in state.app.exigencias) {
      if (state.app.exigencias[exigencia].changed) exigenciasAlteradas[exigencia] = state.app.exigencias[exigencia].ideal_raw
    }
    let restricoes = {}
    let alimentosSelecionados = []
    let alimentosAlterados = {}
    let alsel = JSON.parse(JSON.stringify(state.app.alimentos_selecionados))
    for (let a of Object.values(alsel)) {
      let fator = 1
      switch (a.unidade) {
        case 'kg':
          fator = 1
          break
        case 'g':
          fator = 1 / 1000
          break
        case 'mg':
          fator = 1 / 1000000
          break
        default:
          fator = 1
      }
      a.custo = (a.custo !== null && typeof a.custo === 'string' && a.custo.trim() !== '') ? parseString(a.custo, state.app.idioma) : a.custo
      a.quantidade = (a.quantidade !== null && typeof a.quantidade === 'string' && a.quantidade.trim() !== '') ? parseString(a.quantidade, state.app.idioma) : a.quantidade
      restricoes[a.id] = ((!a.alterado) ? { quantidade: a.quantidade, unidade: a.unidade, fator: fator, custo: a.custo } : { quantidade: a.quantidade, custo: a.custo, unidade: a.unidade, fator: fator, nutrientes: a.nutrientes })
      alimentosSelecionados.push(a.id)
      if (a.alterado) {
        alimentosAlterados[a.id] = a.nutrientes
      }
    }
    dieta = { nome: name, time: new Date().getTime(), animal, restricoes, alimentos_selecionados: alimentosSelecionados, alimentos_alterados: alimentosAlterados, resultado, tipo_alimento_predicao: state.app.tipo_alimento_predicao, exigencias_selecionadas: exigenciasSelecionadas, exigencias_alteradas: exigenciasAlteradas, user_id: state.app.user.id }
    if ((cliente && cliente !== null) || idCliente !== null) {
      dieta["id_cliente"] = idCliente !== null ? idCliente : cliente.id;
    }
    dietas.push(dieta)

    localStorage.setItem('predicoes__', JSON.stringify(dietas))
    return dieta
  }
  const updatePredicao = (state, dietaCarregada, obs = null) => {
    let dietas = JSON.parse(localStorage.getItem('predicoes__'))
    let cliente = JSON.parse(localStorage.getItem('cliente'))
    if (dietas === null || Object.keys(dietas).length === 0) {
      dietas = []
    }
    let dietasEncontradas = dietas.find(n => n.nome === name)
    if (dietasEncontradas !== undefined) {
      name += new Date().getTime()
    }
    let dieta = dietaCarregada
    // crfia objeto para animal;
    let animal = state.app.animal_.getMobileData()
    let resultado = {}
    for (let id in state.app.composicao_racao['MN'].alimentos) {
      resultado[id] = state.app.composicao_racao['MN'].alimentos[id].valor
    }
    let exigenciasSelecionadas = Array.from(state.app.exigencias_selecionadas)
    let exigenciasAlteradas = {}
    for (let exigencia in state.app.exigencias) {
      if (state.app.exigencias[exigencia].changed) exigenciasAlteradas[exigencia] = state.app.exigencias[exigencia].ideal_raw
    }
    let restricoes = {}
    let alimentosSelecionados = []
    let alimentosAlterados = {}
    let alsel = JSON.parse(JSON.stringify(state.app.alimentos_selecionados))
    for (let a of Object.values(alsel)) {
      let fator = 1
      switch (a.unidade) {
        case 'kg':
          fator = 1
          break
        case 'g':
          fator = 1 / 1000
          break
        case 'mg':
          fator = 1 / 1000000
          break
        default:
          fator = 1
      }
      a.custo = (a.custo !== null && typeof a.custo === 'string' && a.custo.trim() !== '') ? parseString(a.custo, state.app.idioma) : a.custo

      a.quantidade = (a.quantidade !== null && typeof a.quantidade === 'string' && a.quantidade.trim() !== '') ? parseString(a.quantidade, state.app.idioma) : a.quantidade
      restricoes[a.id] = ((!a.alterado) ? { quantidade: a.quantidade, unidade: a.unidade, fator: fator, custo: a.custo } : { quantidade: a.quantidade, unidade: a.unidade, fator: fator, nutrientes: a.nutrientes, custo: a.custo })
      alimentosSelecionados.push(a.id)
      if (a.alterado) {
        alimentosAlterados[a.id] = a.nutrientes
      }
    }
    dieta = { nome: dietaCarregada.nome, time: new Date().getTime(), animal, restricoes, alimentos_selecionados: alimentosSelecionados, alimentos_alterados: alimentosAlterados, resultado, tipo_alimento_predicao: state.app.tipo_alimento_predicao, exigencias_selecionadas: exigenciasSelecionadas, exigencias_alteradas: exigenciasAlteradas, user_id: dietaCarregada.user_id, id: dietaCarregada.id, obs: dieta.obs }
    if (cliente && cliente !== null) {
      dieta['id_cliente'] = cliente.id
    }
    dietas.push(dieta)

    localStorage.setItem('predicoes__', JSON.stringify(dietas))
    return dieta
  }
  const predicao = (dietaCarregada === null) ? savePredicao(state, name, idCliente) : updatePredicao(state, dietaCarregada)
  return Vue.prototype.axios.post('dieta/savePD', (dietaCarregada === null) ? { dieta: JSON.stringify(predicao) } : { id: dietaCarregada.id, dieta: JSON.stringify(predicao) }).then((res) => {
    return res
  })
}
export const removePredicao = ({ commit, state }, dieta) => {
  return Vue.prototype.axios.post('dieta/remove', { id: dieta.id })
}
export const savePredicaoOculta = ({ commit, state }) => {
  const saveDieta = (state, name) => {
    let dietas = JSON.parse(localStorage.getItem('predicoes__'))
    let cliente = JSON.parse(localStorage.getItem('cliente'))
    if (dietas === null || Object.keys(dietas).length === 0) {
      dietas = []
    }
    let dieta = {}
    // crfia objeto para animal;
    let animal = state.app.animal_.getMobileData()
    let resultado = {}
    for (let id in state.app.composicao_racao['MN'].alimentos) {
      resultado[id] = state.app.composicao_racao['MN'].alimentos[id].valor
    }
    let exigenciasSelecionadas = Array.from(state.app.exigencias_selecionadas)
    let exigenciasAlteradas = {}
    for (let exigencia in state.app.exigencias) {
      if (state.app.exigencias[exigencia].changed) exigenciasAlteradas[exigencia] = state.app.exigencias[exigencia].ideal_raw
    }
    let restricoes = {}
    let alimentosSelecionados = []
    let alimentosAlterados = {}
    let alsel = JSON.parse(JSON.stringify(state.app.alimentos_selecionados))
    for (let a of Object.values(alsel)) {
      let fator = 1
      switch (a.unidade) {
        case 'kg':
          fator = 1
          break
        case 'g':
          fator = 1 / 1000
          break
        case 'mg':
          fator = 1 / 1000000
          break
        default:
          fator = 1
      }
      a.custo = (a.custo !== null && typeof a.custo === 'string' && a.custo.trim() !== '') ? parseString(a.custo, state.app.idioma) : a.custo

      a.quantidade = (a.quantidade !== null && typeof a.quantidade === 'string' && a.quantidade.trim() !== '') ? parseString(a.quantidade, state.app.idioma) : a.quantidade
      restricoes[a.id] = ((!a.alterado) ? { quantidade: a.quantidade, unidade: a.unidade, fator: fator, custo: a.custo } : { quantidade: a.quantidade, unidade: a.unidade, fator: fator, nutrientes: a.nutrientes, custo: a.custo })
      alimentosSelecionados.push(a.id)
      if (a.alterado) {
        alimentosAlterados[a.id] = a.nutrientes
      }
    }
    dieta = { nome: '', time: new Date().getTime(), animal, restricoes, alimentos_selecionados: alimentosSelecionados, alimentos_alterados: alimentosAlterados, resultado, tipo_alimento_predicao: state.app.tipo_alimento_predicao, exigencias_selecionadas: exigenciasSelecionadas, exigencias_alteradas: exigenciasAlteradas, user_id: state.app.user.id, oculta: true }
    if (cliente && cliente !== null) {
      dieta['id_cliente'] = cliente.id
    }
    dietas.push(dieta)

    localStorage.setItem('predicoes__', JSON.stringify(dietas))
    return dieta
  }
  const predicao = saveDieta(state, name)
  return Vue.prototype.axios.post('dieta/savePD', { dieta: JSON.stringify(predicao) }).then((res) => {
    let md5hash = createMD5(String(res.data.id))
    state.app.dieta_salva = { assinatura: md5hash, dieta: JSON.parse(res.data.dieta), id: res.data.id }
    return res
  })
}
